import { setField } from "../../helpers"
import { dutchOrderPlatesStore } from "../store"
import { getInitialState } from "."
import { IDOPModel, IFieldsItem } from "../../models"

export function resetData() {
    dutchOrderPlatesStore.setState(getInitialState(), false, "Reset Dutch Order Plates Store")
}

export function setLoading() {
    dutchOrderPlatesStore.setState(
        (state) => {
            return {
                dutchOrderPlates: {
                    ...state.dutchOrderPlates,
                    loading: true,
                    errrMessage: undefined,
                },
            }
        },
        false,
        "Set Loading"
    )
}

export function setLoaded(model: IDOPModel) {
    dutchOrderPlatesStore.setState(
        {
            dutchOrderPlates: {
                model,
                loading: false,
            },
        },
        false,
        "Set Loaded"
    )
}

export function setError() {
    dutchOrderPlatesStore.setState(
        {
            dutchOrderPlates: {
                model: {
                    plate: undefined,
                    articles: undefined,
                },
                errrMessage: "ERROR",
                loading: false,
            },
        },
        false,
        "Set Error"
    )
}

export function updateField(id: string, value: IFieldsItem) {
    dutchOrderPlatesStore.setState(
        (state) => {
            const updatedModel = { ...state.dutchOrderPlates.model }
            setField(updatedModel, id, value)
            return {
                dutchOrderPlates: {
                    ...state.dutchOrderPlates,
                    model: updatedModel,
                },
            }
        },
        false,
        "Update Field"
    )
}
